const styles = {
  resultsContainer: {
    height: "600px",
    width: "680px",
    marginLeft: "102px",
    padding: "10px 30px",
    transform: "translateY(0px)",
    backgroundColor: "#fff",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(155, 155, 155, 0.7)",
      borderRadius: "5px",
    },
    "@media (max-width: 1200px)": {
      height: "90%",
      width: "90%",
      marginLeft: 0,
      marginTop: "18px",
      backgroundColor: "#28334C",
    },
  },
  resultCount: {
    display: "block",
    color: "rgba(99, 115, 164, 1)",
    fontFamily: `CircularStd, Circular Std Book`,
    fontSize: "14px",
    marginBottom: "10px",
    "@media (max-width: 1200px)": {
      color: "#fff",
    },
  },
  results: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
    marginBottom: "10px",
    justifyContent: "center",
  },
};

export default styles;
